import { IAiMasteringStorage } from "@/services/storage/base/storage-abstractions";
import { AiMasteringStorageMixin } from "@/services/storage/storage-mixins/ai-mastering-storage-mixin";

class AiMasteringSessionStorage implements IAiMasteringStorage {
  private storeName = "aiMasteringCache";
  private databaseName = "AiMasteringDB";
  private anonStoreKey = "aiMasteringUserUsageKey";

  aiMasteringStorage = new AiMasteringStorageMixin(
    this.anonStoreKey,
    this.storeName,
    this.databaseName,
  );
}

const aiMasteringSessionStorage = new AiMasteringSessionStorage();
export { aiMasteringSessionStorage };
